import { render, staticRenderFns } from "./StartMenu.vue?vue&type=template&id=3f61b3d4&"
import script from "./StartMenu.vue?vue&type=script&lang=js&"
export * from "./StartMenu.vue?vue&type=script&lang=js&"
import style0 from "./StartMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StartMenu.vue"
export default component.exports